import { User } from '../../graphql-generate/graphql-types';

const getAllUserRoles = (user: User, delimiter = '/'): string | null => {
  if (!user.roles?.length) return null;
  return user.roles.join(delimiter);
};

export default getAllUserRoles;
